"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specialCharacters = void 0;
const characterMap = {
    "\\": "\\",
    "'": "'",
    '"': '"',
    n: "\n",
    r: "\r",
    f: "\f",
    t: "\t",
    v: "\v",
};
const reSpecialCharacters = /\\([\\'"nrftv])/g;
function specialCharacters(str) {
    if (!str || str.length < 2) {
        return str;
    }
    // This is a global regex, so we need to reset lastIndex
    reSpecialCharacters.lastIndex = 0;
    return str.replace(reSpecialCharacters, (_match, character) => characterMap[character]);
}
exports.specialCharacters = specialCharacters;
//# sourceMappingURL=special-characters.js.map